const PASSWORD_REQUIREMENTS = {
  minLength: 10,
  hasUppercase: /[A-Z]/,
  hasLetter: /[a-zA-Z]/,
  hasNumber: /[0-9]/,
  hasSpecial: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/,
};

export function generatePassword(): string {
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "!@#$%^&*()_+-=[]{}";

  let password = "";
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += special[Math.floor(Math.random() * special.length)];

  const allChars = uppercase + lowercase + numbers + special;
  for (let i = password.length; i < 10; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  return password
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");
}

export function validatePassword(password: string): {
  valid: boolean;
  errors: string[];
} {
  const errors: string[] = [];

  if (password.length < PASSWORD_REQUIREMENTS.minLength) {
    errors.push("At least 10 characters");
  }
  if (!PASSWORD_REQUIREMENTS.hasUppercase.test(password)) {
    errors.push("At least 1 uppercase letter");
  }
  if (!PASSWORD_REQUIREMENTS.hasLetter.test(password)) {
    errors.push("At least 1 letter");
  }
  if (!PASSWORD_REQUIREMENTS.hasNumber.test(password)) {
    errors.push("At least 1 number");
  }
  if (!PASSWORD_REQUIREMENTS.hasSpecial.test(password)) {
    errors.push("At least 1 special character");
  }

  return { valid: errors.length === 0, errors };
}
